module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin Kinghorn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Kevin Kinghorn is professor of philosophy and religion at Asbury Theological Seminary. He is author of "), _c('I', [_vm._v("The Decision of Faith: Can Christian Beliefs Be Freely Chosen?")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EwWbPk/tc-custom/9780268084653.jpg?1705007642546",
      "alt": "This image is the cover for the book Framework for the Good"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Framework for the Good\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This book provides an ethical framework for understanding the good and how we can experience it in increasing measure. In Part 1, Kevin Kinghorn offers a formal analysis of the meaning of the term \"good,\" the nature of goodness, and why we are motivated to pursue it. Setting this analysis within a larger ethical framework, Kinghorn proposes a way of understanding where noninstrumental value lies, the source of normativity, and the relationship between the good and the right. Kinghorn defends a welfarist conception of the good along with the view that mental states alone directly affect a person's well-being. He endorses a Humean account of motivation—in which desires alone motivate us, not moral beliefs—to explain the source of the normative pressure we feel to do the good and the right. Turning to the place of objectivity within ethics, he concludes that the concept of \"objective wrongness\" is a misguided one, although a robust account of \"objective goodness\" is still possible. In Part 2, Kinghorn shifts to a substantive, Christian account of what the good life consists in as well as how we can achieve it. Hume's emphasis of desire over reason is not challenged but rather endorsed as a way of understanding both the human capacity for choice and the means by which God prompts us to pursue relationships of benevolence, in which our ultimate flourishing consists.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Notre Dame Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0